import useTelehealth from '@/hooks/useTelehealth';
import ArrowLeft from '../../../../../../../packages/ui/ds/icons/TelehealthIcons/ArrowLeft';
import { redirectToPlumApp } from '@/utils';
import { useQuery } from '@tanstack/react-query';
import { getAppointmentDetails } from '@/queries/telehealth.queries';
import toast from 'react-hot-toast';
import sleep from '@/utils/sleep';
import { EAppointmentState } from '@/types';
import useBreakpoints from '@/hooks/useBreakpoints';
import { ChevronLeft } from 'ui/retail-ds/icons';

export default function RejoinCallPage() {
  const { isDesktop } = useBreakpoints();
  const { appointmentId, redirectToFeedbackPage, navigateToCallPage } =
    useTelehealth();
  const { refetch } = useQuery({
    ...getAppointmentDetails({
      appointmentId: appointmentId ? appointmentId : '',
    }),
    queryKey: ['getAppointmentDetailsRefetch'],
    enabled: false,
    staleTime: 0,
  });

  const checkIfEligibleToJoin = async () => {
    /**
     * Throtlling since the doctor's end call might update with a little delay
     */
    await sleep(1000);
    const result = await refetch();
    if (result?.data?.state === EAppointmentState.COMPLETED) {
      toast.success(
        'The call has been completed, redirecting to feedback page',
        {
          style: {
            maxWidth: '500px',
            width: 'fit-content',
          },
        },
      );
      setTimeout(() => {
        redirectToFeedbackPage();
      }, 1000);
    } else {
      navigateToCallPage();
    }
  };

  return (
    <div 
      className="min-h-screen bg-surface-100 h-full flex flex-col font-body pt-20 gap-none lg:gap-[208px]"
      role="main"
      aria-label="Rejoin call page"
    >
      <button
        onClick={() => redirectToPlumApp('/benefits-revamp')()}
        className="text-primary-500 hover:text-primary-600 md:ml-40 self-start flex gap-2 items-center justify-center font-semibold ml-4 lg:ml-20 text-sm"
        aria-label="Go back to homescreen"
        role="navigation"
      >
        {isDesktop ? (
          <>
            <ArrowLeft color="#ee4f5e" aria-hidden="true" />
            <p>Go back to homescreen</p>
          </>
        ) : (
          <ChevronLeft height={24} width={24} fill="#000" aria-hidden="true" />
        )}
      </button>
      <div 
        className="flex flex-col gap-4 my-auto lg:my-0 items-center"
        role="region"
        aria-label="Call status and rejoin options"
      >
        <h1 className="font-chromatica text-[32px] font-[700]">
          Your call has ended
        </h1>
        <button
          onClick={checkIfEligibleToJoin}
          className="px-5 py-3 text-primary-500 hover:text-primary-600 border-primary-500 border rounded-lg"
          aria-label="Rejoin the call"
          role="button"
        >
          Rejoin call
        </button>
      </div>
    </div>
  );
}
